//import DynamicSVG from './DynamicSVG'
import RaidMap from './RaidMap'

export default () => (
  <RaidMap/>
)